import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'user-avatar',
  templateUrl: 'user-avatar.html',
})
export class UserAvatarComponent {
  @Input() isVIP: true;
  @Input() avatarPx = 80;
  // Image metadata wrapper
  @Input()
  metadata: any = {};
  @Input()
  allowOpen = false;
  @Input()
  url: 'assets/imgs/UserRegistration.png';
  @Input()
  inPhotoSlider = false;
  @Output()
  opened = new EventEmitter();
  @Output()
  loaded = new EventEmitter();

  // NOTE: MAKE PARENT ELEMENT POSITION: RELATIVE

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/user-avatar/user-avatar.ts